import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    const exchange = async () => {
      try {
        const res = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data);
        toast.success(`Welcome to Southside, ${res.data.name?.split(" ")[0] || "runner"}`);
        navigate("/profile", { replace: true, state: { user: res.data } });
      } catch {
        toast.error("Sign in failed. Please try again.");
        navigate("/", { replace: true });
      }
    };
    exchange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-plum-900 flex flex-col items-center justify-center gap-4" data-testid="auth-callback-loading">
      <div className="h-10 w-10 rounded-full border-2 border-sunset-amber border-t-transparent animate-spin" />
      <p className="text-muted-foreground text-sm">Signing you in...</p>
    </div>
  );
}
